export default __webpack_public_path__ + "static/media/Background_00288.00fa1ed8.png";